import { z } from 'zod';

export const getAddressListSchema = z.object({
	suggestions: z.array(z.object({
		address: z.string(),
		id: z.string(),
		url: z.string(),
	}))
});
